import React from 'react';
import { TestCase } from '../../../types';

interface TestCaseLineItemProps {
  testCase: TestCase;
  projectCode?: string;
  isSelected: boolean;
  onSelect: (testCaseId: string, selected: boolean) => void;
  onClick: (testCase: TestCase) => void;
}

const TestCaseLineItem: React.FC<TestCaseLineItemProps> = ({
  testCase,
  projectCode,
  isSelected,
  onSelect,
  onClick
}) => {
  const tcId = projectCode && testCase.testCaseNumber 
    ? `${projectCode}-TC-${testCase.testCaseNumber}` 
    : testCase.id.substring(0, 8);

  // Determine automation status badge
  const getAutomationBadge = () => {
    if (testCase.automated) {
      return <span className="automation-badge automation-badge-auto">[AUTO]</span>;
    } else if (testCase.automationCandidate) {
      return <span className="automation-badge automation-badge-candidate">[TO BE AUTOMATED]</span>;
    } else {
      return <span className="automation-badge automation-badge-manual">[MANUAL]</span>;
    }
  };

  const handleDragStart = (e: React.DragEvent) => {
    e.dataTransfer.setData('testCaseId', testCase.id);
    e.dataTransfer.effectAllowed = 'move';
    if (e.currentTarget instanceof HTMLElement) {
      e.currentTarget.style.opacity = '0.5';
    }
  };

  const handleDragEnd = (e: React.DragEvent) => {
    if (e.currentTarget instanceof HTMLElement) {
      e.currentTarget.style.opacity = '1';
    }
  };

  return (
    <div 
      className={`library-testcase-row ${isSelected ? 'selected' : ''}`}
      onClick={() => onClick(testCase)}
      draggable
      onDragStart={handleDragStart}
      onDragEnd={handleDragEnd}
    >
      <div className="library-checkbox-cell">
        <input
          type="checkbox"
          checked={isSelected}
          onChange={(e) => {
            e.stopPropagation();
            onSelect(testCase.id, e.target.checked);
          }}
          onClick={(e) => e.stopPropagation()}
          className="library-checkbox"
        />
      </div>
      
      <div className="library-testcase-id">
        {tcId}
      </div>
      
      <div className="library-testcase-title">
        {testCase.title}
      </div>
      
      <div>
        {getAutomationBadge()}
      </div>
    </div>
  );
};

export default TestCaseLineItem;
